<div class="pre-routine-type-container">
  <app-compliance-tasks
    [columns]="columns"
    [data]="details"
    [isLoading]="isLoading"
    [hasError]="hasError"
    [isComplianceTasks]="true"
    [minWidth]="1100"
    (rowClicked)="onRowClick($event)"
    (actionClicked)="onActionClick($event)">
  </app-compliance-tasks>

  <app-routine-video-cards
    [videos]="videos"
    [isLoading]="videosLoading"
    (videoClicked)="onVideoClick($event)">
  </app-routine-video-cards>
</div>